<template>
  <div class="category-groups-admin">
    <v-card>
      <!-- **************************** -->
      <v-card-title data-cy="title">
        Category Groups
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          :prepend-icon="svgMagnify"
          label="Search"
          clearable
          style="margin-left:250px;"
        ></v-text-field>
      </v-card-title>

      <!-- **************************** -->
      <v-card-actions class="mb-1">
        <v-spacer></v-spacer>
        <v-btn data-cy="plus-btn" text @click="addCategoryGroup()">
          <v-icon>
            {{ svgPlus }}
          </v-icon>
        </v-btn>
      </v-card-actions>

      <!-- **************************** -->
      <v-data-table :headers="headers" :items="items" :search="search" :items-per-page="5" class="elevation-1">
        <template v-slot:item.action="{ item }">
          <!--  -->
          <v-icon @click="editItem(item)">
            {{ svgPencil }}
          </v-icon>
          <!--  -->
          <v-icon @click="deleteItem(item)">
            {{ svgDelete }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card v-if="selectedCategoryGroups">
        <v-card-title class="text-h5 grey lighten-2" primary-title>
          Delete - {{ selectedCategoryGroups.name }}
        </v-card-title>

        <v-card-text>
          Press OK to delete this Category Group.
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteCategoryGroups()">OK</v-btn>
          <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mdiPencil, mdiDelete } from "@mdi/js";
import { mdiMagnify } from "@mdi/js";
import { mdiPlus } from "@mdi/js";

export default {
  name: "CategoryGroups",
  components: {},
  data: () => ({
    search: "",
    svgPlus: mdiPlus,
    svgMagnify: mdiMagnify,
    svgPencil: mdiPencil,
    svgDelete: mdiDelete,
    dialog: false,
    selectedCategoryGroups: null,
    pagination: {
      sortBy: "name",
      descending: true,
      rowsPerPage: 5,
    },
    headers: [
      { text: "ID", value: "id" },
      { text: "Name", value: "name" },
      { text: "Description", value: "description" },
      { text: "Action", value: "action", sortable: false, width: "10%" },
    ],
  }),
  created() {
    this.$store.dispatch("getCategoryGroupsList");
  },

  computed: {
    ...mapGetters({
      items: "getCategoryGroupsList",
    }),
  },

  methods: {
    editItem(item) {
      if (!item) {
        return;
      }
      this.selectedCategoryGroups = item;
      this.$store.dispatch("selectedCategoryGroups", item);
      this.$router.push({ name: "CategoryGroupsDetails" });
    },
    addCategoryGroup() {
      this.$store.dispatch("selectedCategoryGroups", null);
      this.$router.push({ name: "CategoryGroupsDetails" });
    },
    deleteItem(item) {
      if (!item) {
        return;
      }
      this.selectedCategoryGroups = item;
      this.dialog = true;
    },
    deleteCategoryGroups() {
      this.dialog = false;
      if (!this.selectedCategoryGroups) {
        return;
      }
      this.$store.dispatch("deleteCategoryGroups", this.selectedCategoryGroups);
    },
  },
};
</script>

<style lang="scss">
.category-groups-admin {
}
</style>
